import { AxiosService } from './axiosService';

const paths = {
    priorities: '/task-priorities',
    statuses: '/task-statuses',
    types: '/task-types',
};

export class TaskOptionsService extends AxiosService {
    async getOptions(kind) {
        const { data } = await this.axios.get(paths[kind]);
        return data;
    }

    async createOption(kind, name) {
        const { data } = await this.axios.post(paths[kind], { name });
        return data;
    }

    async updateOption(kind, id, name) {
        const { data } = await this.axios.put(paths[kind], { id, name });
        return data;
    }

    async deleteOption(kind, id) {
        const { data } = await this.axios.delete(`${paths[kind]}/${id}`);
        return data;
    }

    async getUsage(kind, id) {
        const { data } = await this.axios.get(`${paths[kind]}/${id}/usage`);
        return data;
    }
}

export const taskOptionsService = new TaskOptionsService();
